import { pages } from "@/services/requests";
import { IBrands, IBrandsGeneric } from "global-types/global.types";
import { useQuery } from "react-query";

interface Props {
  params: {
    a: string | null;
  };
  initialData: IBrands<IBrandsGeneric[]>;
  onSuccess: (data: Props["initialData"]) => void;
}

function useBrands({ initialData, params, onSuccess }: Props) {
  const { data, isLoading } = useQuery(["BRANDS_PAGE", params], pages.brands, {
    initialData,
    staleTime: 0,
    onSuccess,
  });

  return { data, isLoading };
}

export default useBrands;
